import React, { useEffect, useRef } from 'react';
import { buildStaticUrl } from '../../services/supportApi';
import { typesetElement } from '../../lib/mathjax';

interface RichHtmlProps {
  html: string;
  className?: string;
}

/**
 * 渲染试卷富文本：题干/选项/子问的 HTML（含内联 MathML、img、table）。
 * - 图片相对路径 /uploads/... 用 buildStaticUrl 拼成完整 URL（支持独立静态域名）
 * - 渲染后调用 MathJax 对 MathML 排版
 */
function rewriteImgSrc(html: string): string {
  if (!html) return '';
  return html.replace(/(<img[^>]*\bsrc=")([^"]*)(")/gi, (m, pre, src, post) => {
    // 只重写站内相对资源；外链原样
    if (/^https?:\/\//i.test(src)) return m;
    return `${pre}${buildStaticUrl(src)}${post}`;
  });
}

export const RichHtml: React.FC<RichHtmlProps> = ({ html, className }) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.innerHTML = rewriteImgSrc(html || '');
    // 排版 MathML（异步，失败降级为原始）
    typesetElement(el);
  }, [html]);

  // 统一约束富文本内图片：去掉数据自带的固定 px 尺寸，改为自适应容器、保持比例。
  // 覆盖题干/选项/子问所有使用场景（做题页、报告详情等）。
  const imgFit = '[&_img]:!max-w-full [&_img]:!h-auto [&_img]:!w-auto';
  return <div ref={ref} className={`${imgFit}${className ? ` ${className}` : ''}`} />;
};
